import { autoinject } from 'aurelia-framework';
import { ApiService, CancellationToken } from '../../utils/api-service';

@autoinject
export class FinancialEntryService {
	private cancellationTokens: { [key: string]: CancellationToken } = {};

	constructor(private api: ApiService) {
	}

	getFinancialEntriesOfCostCenter(
		scopeId: string,
		costCenterId: string,
		sourceFilter: string): Promise<IFinancialEntryDataAM[]> {

		const cancellationToken = this.cancelToken('getFinancialEntriesOfCostCenter');

		return this.api.fetchJson(
			`cost-centers/${costCenterId}/financial-entries?scopeId=${scopeId}&sourceFilter=${sourceFilter}`,
			null,
			null,
			cancellationToken);
	}

	private cancelToken(name: string) {
		let cancellationToken = this.cancellationTokens[name];

		if (cancellationToken) {
			cancellationToken.cancel();
		}

		cancellationToken = new CancellationToken();
		this.cancellationTokens[name] = cancellationToken;

		return cancellationToken;
	}
}

export interface IFinancialEntryDataAM {
	summaryGroups: IFinancialEntryAM[];
	accountGroups: IFinancialEntryAccountGroupAM[];
	total: number;
}

export interface IFinancialEntryAccountGroupAM {
	id: string;
	nameText: string;
	accountClass: string;
	sortOrder: number;
	accounts: IFinancialEntryAccountAM[];
	total: number;
}

export interface IFinancialEntryAccountAM {
	id: string;
	accountNumber: string;
	name: string;
	dimensionValues: IFinancialEntryDimensionValueAM[];
	total: number;
}

export interface IFinancialEntryDimensionValueAM {
	title: string;
	financialEntries: IFinancialEntryAM[];
}

export interface IFinancialEntryAM {
	amount: number;
	source: string;
	type: string;
	created: string;
	isCounterEntry: boolean;
	serviceName: string;
	municipalityName: string;
	sourceAccountingRule: IFinancialEntrySourceAccountingRuleAM;
}

export interface IFinancialEntrySourceAccountingRuleAM {
	id: string;
	name: string;
	ruleIndex: number;
	definition: string;
	isAllowedAccessAccountingRules: boolean;
}
